export default "__VITE_PUBLIC_ASSET__9774c754__"